import { useState, ReactElement } from 'react';
import * as React from 'react';


interface CheckoutWizardProps {
    stepsData: Array<(props: CheckoutStepProps) => ReactElement>;
    sendingOrderResponse: boolean;
    onCurrentStepChanged: (step) => void;
    sendSummaryOrderResponse?: () => void;
}

interface CheckoutStepProps {
    sendingOrderResponse: boolean;
    onNext: () => void;
    onSendSummaryOrderResponse?: () => void;
}

const CheckoutWizard: React.FC<CheckoutWizardProps> = ({
    stepsData, sendingOrderResponse, onCurrentStepChanged, sendSummaryOrderResponse
}) => {
    const [currentStep, setCurrentStep] = useState(0);

    const goToNextStep = () => {
        var step = currentStep + 1;
        setCurrentStep(step);
        onCurrentStepChanged(step);
    }

    const StepComponent = stepsData[currentStep];

    return (
        <>
            <StepComponent
                onNext={(currentStep === stepsData.length - 1) ? undefined : goToNextStep}
                onSendSummaryOrderResponse={sendSummaryOrderResponse}
                sendingOrderResponse={sendingOrderResponse}
            />
        </>
    );
};

export default CheckoutWizard;